/* eslint-disable @typescript-eslint/no-duplicate-enum-values */ /**
 * TODO: Please address the newly added events in `src/components/organisms/notifications/list/line-item/message.tsx`

 * The notification page crashes if the new events are not handled gracefully.
 */ export var EventType = /*#__PURE__*/ function(EventType) {
    EventType["MessageCreated"] = "MessageCreated";
    EventType["UserMentionedInMessage"] = "UserMentioned";
    EventType["UserMentionedInDocument"] = "UserMentionedInDocument";
    EventType["UserMentionedInTask"] = "UserMentionedInTask";
    EventType["MessageReactionAdded"] = "MessageReactionAdded";
    EventType["MessageReplyAdded"] = "MessageReplyAdded";
    EventType["TaskCreated"] = "TaskCreated";
    EventType["TaskNameOrDescriptionChanged"] = "TaskNameOrDescriptionChanged";
    EventType["TaskPrivateNoteChanged"] = "TaskPrivateNoteChanged";
    EventType["TaskAtRiskChanged"] = "TaskAtRiskChanged";
    EventType["TaskStatusChanged"] = "TaskStatusChanged";
    EventType["TaskAssignedToUser"] = "TaskAssignedToUser";
    EventType["TaskAssigneeChanged"] = "TaskAssigneeChanged";
    EventType["TaskFormResponseChanged"] = "TaskFormResponseChanged";
    EventType["DependentTaskChanged"] = "DependentTaskChanged";
    EventType["TaskPriorityChanged"] = "TaskPriorityChanged";
    EventType["TaskEstimateChanged"] = "TaskEstimateChanged";
    EventType["TaskAttachmentChanged"] = "TaskAttachmentChanged";
    EventType["TaskFollowerAdded"] = "TaskFollowerAdded";
    EventType["TaskFieldChanged"] = "TaskFieldChanged";
    EventType["TaskDependencyStatusChanged"] = "TaskDependencyStatusChanged";
    EventType["TaskPhaseChanged"] = "TaskPhaseChanged";
    EventType["DocumentCreated"] = "DocumentCreated";
    EventType["DocumentChanged"] = "DocumentChanged";
    EventType["MeetingNoteCreated"] = "MeetingNoteCreated";
    EventType["MeetingNoteChanged"] = "MeetingNoteChanged";
    EventType["TaskStartDateChanged"] = "TaskStartDateChanged";
    EventType["TaskDueDateChanged"] = "TaskDueDateChanged";
    EventType["TaskDueDateOverdue"] = "TaskDueDateOverdue";
    EventType["TaskStartDateReminder"] = "TaskStartDateReminder";
    EventType["TaskDueDateReminder"] = "TaskDueDateReminder";
    EventType["ProjectNameChanged"] = "ProjectNameChanged";
    EventType["ProjectStatusChanged"] = "ProjectStatusChanged";
    EventType["ProjectStartDateChanged"] = "ProjectStartDateChanged";
    EventType["ProjectDueDateChanged"] = "ProjectDueDateChanged";
    EventType["ProjectPhaseAdded"] = "ProjectPhaseAdded";
    EventType["ProjectPhaseRemoved"] = "ProjectPhaseRemoved";
    EventType["ProjectPhaseNameChanged"] = "ProjectPhaseNameChanged";
    EventType["ProjectPhaseStatusChanged"] = "ProjectPhaseStatusChanged";
    EventType["ProjectPhaseStartDateChanged"] = "ProjectPhaseStartDateChanged";
    EventType["ProjectPhaseDueDateChanged"] = "ProjectPhaseDueDateChanged";
    EventType["ProjectCsatAdded"] = "ProjectCSATAdded";
    EventType["ProjectStatusUpdatePublished"] = "ProjectStatusUpdatePublished";
    EventType["ProjectMemberAdded"] = "ProjectMemberJoinedMyProject";
    EventType["ProjectMemberRemoved"] = "ProjectMemberLeftMyProject";
    EventType["ProjectConversationMemberAdded"] = "ProjectConversationMemberAdded";
    EventType["ProjectConversationMemberInvited"] = "ProjectConversationMemberInvited";
    EventType["ProjectDeleted"] = "ProjectDeleted";
    EventType["ProjectArchived"] = "ProjectArchived";
    EventType["ProjectUnarchived"] = "ProjectUnarchived";
    EventType["UserAddedToProject"] = "ProjectMemberAddedToAnotherProject";
    EventType["ApprovalRequested"] = "ApprovalRequested";
    EventType["ApprovalRequestChangesRequested"] = "ApprovalRequestChangesRequested";
    EventType["ApprovalRequestApproved"] = "ApprovalRequestApproved";
    EventType["TimesheetDueReminder"] = "TimesheetDueReminder";
    EventType["TimesheetOverdueReminder"] = "TimesheetOverdueReminder";
    EventType["TimesheetSubmitted"] = "TimesheetSubmitted";
    EventType["TimesheetRequested"] = "TimesheetRequested";
    EventType["TimesheetApproved"] = "TimesheetApproved";
    EventType["TimesheetRejected"] = "TimesheetRejected";
    EventType["ProjectFolderAttachmentAdded"] = "ProjectFolderAttachmentAdded";
    EventType["ProjectFolderAttachmentRemoved"] = "ProjectFolderAttachmentRemoved";
    EventType["ProjectFolderAttachmentChanged"] = "ProjectFolderAttachmentChanged";
    EventType["MessageCreatedInTask"] = "MessageCreatedInTask";
    EventType["MessageCreatedInDocumentSpaceTab"] = "MessageCreatedInDocumentSpaceTab";
    EventType["MessageCreatedInDocumentStatusUpdate"] = "MessageCreatedInDocumentStatusUpdate";
    EventType["MessageCreatedInProjectConversation"] = "MessageCreatedInProjectConversation";
    EventType["ProjectFieldUpdated"] = "ProjectFieldUpdated";
    EventType["TaskRequestApproval"] = "TaskRequestApproval";
    EventType["ProjectSpaceCreated"] = "ProjectSpaceCreated";
    EventType["ProjectDocumentAdded"] = "ProjectDocumentAdded";
    EventType["ProjectDocumentApprovalRequests"] = "ProjectDocumentApprovalRequests";
    EventType["ProjectDocumentComments"] = "ProjectDocumentComments";
    EventType["StartDateReminders"] = "StartDateReminders";
    EventType["DueDateReminders"] = "DueDateReminders";
    EventType["DigestTask"] = "DigestTask";
    EventType["DigestWeekly"] = "DigestWeekly";
    EventType["TaskAnyFieldExceptStatusChanged"] = "TaskAnyFieldExceptStatusChanged";
    EventType["TaskProgressChanged"] = "TaskProgressChanged";
    EventType["ProjectMemberChanged"] = "ProjectMemberChanged";
    EventType["ProjectMemberJoinedMyProject"] = "ProjectMemberJoinedMyProject";
    EventType["ProjectMemberLeftMyProject"] = "ProjectMemberLeftMyProject";
    EventType["ProjectAnyFieldChanged"] = "ProjectAnyFieldChanged";
    EventType["ProjectStartDateOrDueDateChanged"] = "ProjectStartDateOrDueDateChanged";
    EventType["ProjectCSATAdded"] = "ProjectCSATAdded";
    EventType["ProjectPhaseStartDateOrDueDateChanged"] = "ProjectPhaseStartDateOrDueDateChanged";
    EventType["DigestTaskDueDateReminder"] = "DigestTaskDueDateReminder";
    EventType["DigestTaskStartDateReminder"] = "DigestTaskStartDateReminder";
    EventType["DigestTaskWeekly"] = "DigestTaskWeekly";
    EventType["AllApprovalEvents"] = "AllApprovalEvents";
    EventType["TimeOffCreated"] = "TimeOffCreated";
    EventType["TimeOffDeleted"] = "TimeOffDeleted";
    EventType["ProjectPhaseUpdates"] = "ProjectPhaseUpdates";
    EventType["ProjectBudgetThresholdReached"] = "ProjectBudgetThresholdReached";
    EventType["ProjectHoursThresholdReached"] = "ProjectHoursThresholdReached";
    EventType["ProjectPartnerAddition"] = "ProjectPartnerAddition";
    EventType["ProjectPlaceholderResolve"] = "ProjectPlaceholderResolve";
    EventType["NotifyThroughAutomation"] = "NotifyThroughAutomation";
    EventType["NoteAdded"] = "NoteAdded";
    EventType["NoteUpdated"] = "NoteUpdated";
    EventType["ResourceRequestApproved"] = "ResourceRequestApproved";
    EventType["ResourceRequestAssigneeChanged"] = "ResourceRequestAssigneeChanged";
    EventType["ResourceRequestAssigneeUpdated"] = "ResourceRequestAssigneeUpdated";
    EventType["ResourceRequestSetAssignee"] = "ResourceRequestSetAssignee";
    EventType["ResourceRequestStatusChanged"] = "ResourceRequestStatusChanged";
    EventType["ResourceRequestBlocked"] = "ResourceRequestBlocked";
    EventType["InvoiceCreated"] = "InvoiceCreated";
    EventType["InvoiceStatusChanged"] = "InvoiceStatusChanged";
    EventType["InvoicePaymentAdded"] = "InvoicePaymentAdded";
    EventType["InvoicePaymentRemoved"] = "InvoicePaymentRemoved";
    EventType["InvoicePaymentWrittenOff"] = "InvoicePaymentWrittenOff";
    EventType["InvoiceWrittenOffPaymentRemoved"] = "InvoiceWrittenOffPaymentRemoved";
    EventType["InvoiceDeleted"] = "InvoiceDeleted";
    EventType["ApprovalWorkFlowRequestedOnInvoice"] = "ApprovalWorkFlowRequestedOnInvoice";
    EventType["ApprovalWorkFlowStatusChangedOnInvoice"] = "ApprovalWorkFlowStatusChangedOnInvoice";
    EventType["ApprovalWorkFlowDueRemainderOnInvoice"] = "ApprovalWorkFlowDueRemainderOnInvoice";
    EventType["ApprovalWorkFlowOverDueRemainderOnInvoice"] = "ApprovalWorkFlowOverDueRemainderOnInvoice";
    EventType["BillingEventReminder"] = "BillingEventReminder";
    EventType["ExpenseSubmitted"] = "ExpenseSubmitted";
    EventType["ExpenseApproved"] = "ExpenseApproved";
    EventType["ExpenseRejected"] = "ExpenseRejected";
    EventType["SheetDeleted"] = "SheetDeleted";
    EventType["SheetTabCreated"] = "SheetTabCreated";
    EventType["SheetTabStatusUpdated"] = "SheetTabStatusUpdated";
    EventType["SheetTabAssigneeUpdated"] = "SheetTabAssigneeUpdated";
    EventType["SheetTabDueDateUpdated"] = "SheetTabDueDateUpdated";
    EventType["SheetTabNameChanged"] = "SheetTabNameChanged";
    EventType["SheetTabAssignedToUser"] = "SheetTabAssignedToUser";
    EventType["SheetTabDeleted"] = "SheetTabDeleted";
    EventType["SheetRowAssignedToUser"] = "SheetRowAssignedToUser";
    return EventType;
}({});
